import api from '@/libs/axiosInstance';
import type { ApiResponse } from '@fluenceur/types';
import { useMutation } from '@tanstack/react-query';

const requestPasswordResetRequest = async (email: string): Promise<ApiResponse> => {
  const response = await api.post<ApiResponse>('/auth/password-reset/request', { email });

  if (response.data?.success !== true) {
    throw new Error(response.data?.message || 'Failed to send password reset email');
  }

  return response.data;
};

export const useRequestPasswordResetAction = () =>
  useMutation<ApiResponse, Error, string>({
    mutationFn: requestPasswordResetRequest,
  });
